import React, { useState } from "react";
// import Logo from "../../../common/Logo";
import useLogout from "../../../common/useLogout";
import "components/common/Cancelation/cancelation.css";
import "components/client/dashboard/Reps/repCard/repCard.css";
import { ICONS } from "components/common/constants/swal.constants";
import GenericModal from "components/common/GenericModal";
import { CheckCircle2, X, Mail, CircleCheck, AlertCircle } from "lucide-react";
const NotConfirmedMessage = () => {
  const [genericModalData, setGenericModalData] = useState({
    show: false,
  });
  const showLogoutSuccess = () => {
    setGenericModalData({
      show: true,
      title: "Goodbye",
      subtext: "See you next time!",
      icon: ICONS.checkMark,
    });
  };
  const showLogoutError = () => {
    setGenericModalData({
      show: true,
      title: "Oops!",
      subtext: "Some error occurred",
      icon: ICONS.error,
    });
  };
  const hideModal = () => {
    setGenericModalData((prevState) => ({ ...prevState, show: false }));
  };

  const logOut = useLogout(
    "/login",
    showLogoutSuccess,
    showLogoutError,
    hideModal,
  );
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "100vh",
          alignItems: "center",
        }}
        className="OnboardingForm"
      >
        {genericModalData.show && (
          <GenericModal
            show={genericModalData.show}
            onHide={hideModal}
            title={genericModalData?.title || ""}
            subtext={genericModalData?.subtext || ""}
            icon={genericModalData?.icon || undefined}
            hideBtn
          />
        )}
        <div
          style={{
            width: "100%",
            maxWidth: 500,
            margin: "84px 0",
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            flex: 1,
            padding: "1em",
            boxShadow: "1px 3px 18px 0px #0000001A",
            borderRadius: 8,
            position: "relative",
            backgroundColor: "#fff",
          }}
        >
          <button
            onClick={logOut}
            className="dialog-close-btn"
            aria-label="Close dialog"
          >
            <X />
          </button>

          <div className="cm-title-container" style={{ alignSelf: "unset" }}>
            <CheckCircle2 className="success-icon" />
            <p className="modal-title" style={{ display: "flex", flex: 1 }}>
              Welcome
            </p>
            <span className="intro-text">{`Thanks for signing up! We're reviewing your profile now.`}</span>
          </div>
          {/* Warning/Note Callout */}
          <div className="warning-callout">
            <AlertCircle className="warning-icon" />
            <div className="warning-content">
              <h3 className="warning-title">Please note:</h3>
              <p className="warning-text">
                {`You won't be able to log in or book appointments until your
                  profile is approved.`}
              </p>
            </div>
          </div>
          {/* Next Steps List */}
          <div className="list-section">
            <p className="list-intro">
              {`You'll receive an email within 1 business day with either:`}
            </p>
            <ul className="steps-list">
              <li className="step-item">
                <div className="step-icon-box">
                  <CircleCheck className="step-icon-check" />
                </div>
                <span className="step-text">Approval confirmation, or</span>
              </li>
              <li className="step-item">
                <div className="step-icon-box">
                  <Mail className="step-icon-mail" />
                </div>
                <span className="step-text">
                  A request for additional information
                </span>
              </li>
            </ul>
          </div>

          {/* Footer Action */}
          <div className="dialog-footer">
            <button onClick={logOut} className="home-btn">
              Go Back Home
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotConfirmedMessage;
